// extracted by mini-css-extract-plugin
module.exports = {"component":"_2q4anI9XL2rR71FQfxTNb_","emphasis":"_3YcvsfaxZF1ndxqBtRWEYi","text":"_1PUxQr4x7CsW_69T4DMime"};